import { calculateDistanceInMetersAsync } from "@lib/google-maps/calculateDistance";

export const getDistanceFromAddress = async (
  lat,
  lng,
  address,
  selectedTestDrivePoint
) => {
  let basePosition = null;

  if (address) {
    basePosition = { lat: address.geoLat, lng: address.geoLng };
  }

  if (selectedTestDrivePoint) {
    basePosition = {
      lat: selectedTestDrivePoint.geoLatitude,
      lng: selectedTestDrivePoint.geoLongitude,
    };
  }

  if (!basePosition) {
    return null;
  }

  return calculateDistanceInMetersAsync(
    { lat: Number(lat), lng: Number(lng) },
    { lat: Number(basePosition.lat), lng: Number(basePosition.lng) }
  );
};
